import styled from 'styled-components/macro'

export function FBPage({
  children,
  noContainer,
  className,
  innerPageClassName,
  containerClassName,
  headerChildren,
  footerChildren,
}: {
  children: React.ReactNode
  headerChildren?: React.ReactNode
  footerChildren?: React.ReactNode
  noContainer?: boolean
  className?: string
  innerPageClassName?: string
  containerClassName?: string
}) {
  return (
    <PageDiv className={className} data-fb-page>
      {headerChildren}
      <InnerPageDiv className={innerPageClassName}>
        {!noContainer ? (
          <Container className={containerClassName}>{children}</Container>
        ) : (
          children
        )}
      </InnerPageDiv>
      {footerChildren}
    </PageDiv>
  )
}

const PageDiv = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  /* Positioning context so content-scoped overlays (e.g. the reply-templates
     sheet) can span the whole page content via absolute inset-0 while leaving
     the app nav reachable. Safe: no existing absolute children rely on a
     higher ancestor as their offset parent. */
  position: relative;
`

const InnerPageDiv = styled.div`
  padding: var(--page-vertical-padding) var(--page-vertical-padding)
    calc(var(--page-vertical-padding) / 2);
  background-color: #f5f5f5;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`

const Container = styled.div`
  padding: var(--page-container-vertical-padding)
    var(--page-container-horizontal-padding);
  background-color: #fff;
  border-radius: 8px;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  overflow: hidden;
  flex: 1;
  min-height: 0;
`
